export enum NextApptWhenEnum {
    ONE_DAY = '00000226-1000-0000-0000-000000000001',
    TWO_DAYS = '00000226-1000-0000-0000-000000000002',
    THREE_DAYS = '00000226-1000-0000-0000-000000000003',
    ONE_WEEK = '00000226-1000-0000-0000-000000000004',
    ONE_AND_HALF_WEEKS = '00000226-1000-0000-0000-000000000005',
    TWO_WEEKS = '00000226-1000-0000-0000-000000000006',
    THIRTY_DAYS = '00000226-1000-0000-0000-000000000007',
    SIXTY_DAYS = '00000226-1000-0000-0000-000000000008',
    NINETY_DAYS = '00000226-1000-0000-0000-000000000009',
    CONVENIENCE = '00000226-1000-0000-0000-000000000010',
    RECALL = '00000226-1000-0000-0000-000000000011',
    NONE = '00000226-1000-0000-0000-000000000012',
    THREE_WEEKS = '00000226-1000-0000-0000-000000000013',
    SIX_WEEKS = '00000226-1000-0000-0000-000000000014',
    SIX_MONTHS     = '00000226-1000-0000-0000-000000000015'	            
  }
  